import { motion } from 'framer-motion';
import styled from 'styled-components';

export const PeopleSearchBarHistoryWrapper = styled(motion.div).attrs({
  initial: { height: 0 },
  animate: { height: 'auto' },
  exit: { height: 0, overflow: 'hidden' },
})`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  width: 100%;
  max-height: 324px;

  padding: 0px 12px 21px 12px;

  overflow-y: auto;

  ${({ theme }) =>
    (theme.currentStep === 1 || theme.isFocused) && !theme.isLoading
      ? `
      background: #ffffff;
      `
      : `
      background: rgba(255, 255, 255, 0.50);
      backdrop-filter: blur(20px);
      `};
`;

export const PeopleSearchBarHistoryClearButtonContainer = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const PeopleSearchBarHistoryClearCTA = styled.button`
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: right;

  color: rgba(23, 28, 51, 0.5);
`;

export const PeopleSearchBarHistoryList = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  overflow-y: auto;
  gap: 9px;
`;

export const PeopleSearchBarHistoryItem = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  cursor: pointer;
`;

export const PeopleSearchBarHistoryItemDate = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

export const PeopleSearchBarHistoryItemLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;
